export default __webpack_public_path__ + "static/media/hostImgJ1.5ce55137.jpg";